import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import APAgingDash from './APAgingDash';

const APAgingDashScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:APAgingDashScreen')}>
      <APAgingDash />
    </PageContent>
  )
}

export default APAgingDashScreen;